import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "CardListView",
    component: () => import("@/components/pages/CardListView/Component.vue"),
  },
  {
    path: "/CardDetail/:id",
    name: "CardDetail",
    component: () => import("@/components/pages/CardDetail/Component.vue"),
  },
  {
    path: "/form",
    name: "Form",
    component: () => import("@/components/pages/Form/Component.vue"),
  },
  {
    path: "/signin",
    name: "SignIn",
    component: () => import("@/components/pages/Auth/SignIn.vue"),
  },
  {
    path: "/signup",
    name: "SignUp",
    component: () => import("@/components/pages/Auth/SignUp.vue"),
  },
  {
    path: "/password",
    name: "PassWordReset",
    component: () => import("@/components/pages/Auth/PassWordReset.vue"),
  },

  {
    path: "/edit/:id",
    name: "edit",
    component: () => import("@/components/pages/Edit/Component.vue"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
